/* eslint-disable no-undef */
/* eslint-disable radix */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import moment from 'moment';
import MaxLengthNumericEditor from '../../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from '../../../../../SharedModules/StyleConstant/StyleConstant';
import {
  dispatchSummaryGridList,
  SumOfInterest,
  dispatchColIdForRosi,
} from '../../store/Actions';
import {
  handleQuarterFormate,
  removeCommaForNumberFiled,
  removeDollarForNumberFiled,
  handleOnKeyDownEventWithSelectValue,
  removeWhiteSpaceForNDC,
  ndcTextMatcher,
} from '../../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  NumberAndAlphabetComparator,
  amountComparator,
} from '../../../../../SharedModules/utilities/utilities';
import { replaceCommaIntoWhiteSpace } from './ROSIUtils';
import * as constantMessageData from '../../../../../SharedModules/Errors/constantMessageData';
import _ from 'lodash';

function monthToComparableNumber(date) {
  if (date === undefined || date === null || date.length !== 10) {
    return null;
  }
  const yearNumber = Number.parseInt(date.substring(6, 10));
  const dayNumber = Number.parseInt(date.substring(3, 5));
  const monthNumber = Number.parseInt(date.substring(0, 2));
  return yearNumber * 10000 + monthNumber * 100 + dayNumber;
}
function dateComparator(date1, date2) {
  const date1Number = monthToComparableNumber(date1);
  const date2Number = monthToComparableNumber(date2);
  if (date1Number === null && date2Number === null) {
    return 0;
  }
  if (date1Number === null) {
    return -1;
  }
  if (date2Number === null) {
    return 1;
  }
  return date1Number - date2Number;
}

const numberAndTextComparator = (valueA, valueB) => {
  return valueA?.trim()?.localeCompare(valueB?.trim());
};
export const calculateTotalSum = (ColName, rowData, sumGrid) => {
  const newObj = rowData?.length > 0 ? JSON.parse(JSON.stringify(rowData)) : [];
  const displayedRows =
    newObj &&
    newObj?.map((item) => {
      if (ColName === 'paidThisTransactionAmt') {
        if (item.isDeallocate) {
          item[ColName] = parseFloat(0).toFixed(2);
        } else {
          item[ColName] = parseFloat(item[ColName])
            ? parseFloat(
                item[ColName]?.toString()?.replace(',', '').trim()
              ).toFixed(2)
            : parseFloat(0).toFixed(2);
        }
      } else {
        item[ColName] = item[ColName]
          ? parseFloat(item[ColName]?.toString()?.replace(',', '').trim())
          : 0;
      }
      return item;
    });
  let data = 0;
  if (
    (ColName === 'amountOwedNdc' ||
      ColName === 'totReimbursedUnits' ||
      ColName === 'rebateAmtInvoice') &&
    sumGrid
  ) {
    // Step 1: Identify drugSeqNum that have bg != "12632256"
    const drugSeqNumWithBg = new Set(
      displayedRows
        .filter((item) => item.bgColorForNDC != '12632256')
        .map((item) => item?.drugSeqNum)
    );
    // Step 2: Remove items with bg === "12632256" if their ID exists in drugSeqNumWithBg
    const filteredDisplayedRowsArr = displayedRows?.filter(
      (item) =>
        !(
          item.bgColorForNDC === '12632256' &&
          drugSeqNumWithBg.has(item.drugSeqNum)
        )
    );
    data = filteredDisplayedRowsArr?.reduce((a, b) => {
      return a + (b[ColName] ? parseFloat(b[ColName] || 0) : 0);
    }, 0);
  } else {
    data = displayedRows?.reduce((a, b) => {
      return a + parseFloat(b[ColName]);
    }, 0);
  }
  if (
    ColName === 'paidUnits' ||
    ColName === 'disputedUnits' ||
    ColName === 'adjustedUnits' ||
    ColName === 'totReimbursedUnits'
  ) {
    return isNaN(data) ? parseFloat(0).toFixed(3) : parseFloat(data).toFixed(3);
  }
  return isNaN(data) ? parseFloat(0).toFixed(2) : parseFloat(data).toFixed(2);
};
const getAdjDisputeExportValue = (labelField) => (params) => {
  if (params.data?.isBottomRow) return '';
  return params.data?.[labelField] || '';
};

const getAdjDisputeFilterValue = (codeField) => (params) =>
  params.data?.[codeField] ?? '';

const adjDisputeValueSetter = (params) => {
  if (!params.data || !params.colDef?.field) return false;
  params.data[params.colDef.field] = params.newValue;
  return true;
};

export const createNewRowData = (count, rowData) => {
  const result = [];
  for (let i = 0; i < count; i += 1) {
    result.push({
      isBottomRow: true,
      ccCommentsExist: '',
      ccPaidInFullInd: '',
      interestSettledInd: '',
      ccInterestAllocated: '',
      adjustedUnitRebateAmt: 'Totals:',
      ndc: '',
      drugName: '',
      ccAc1: '',
      ccAc2: '',
      ccAc3: '',
      ccDc1: '',
      ccDc2: '',
      ccDc3: '',
      ccAc1ValWithLabel: '',
      ccAc2ValWithLabel: '',
      ccAc3ValWithLabel: '',
      ccDc1ValWithLabel: '',
      ccDc2ValWithLabel: '',
      ccDc3ValWithLabel: '',
      totReimbursedUnits: calculateTotalSum('totReimbursedUnits', rowData, true),
      adjustedUnits: calculateTotalSum('adjustedUnits', rowData),
      disputedUnits: calculateTotalSum('disputedUnits', rowData),
      paidUnits: calculateTotalSum('paidUnits', rowData),
      ccInterestOwed:'',
      invoiceCorrectionAmt: calculateTotalSum('invoiceCorrectionAmt', rowData),
      rebateAmtInvoice: calculateTotalSum('rebateAmtInvoice', rowData, true),
      amountOwedNdc: calculateTotalSum('amountOwedNdc', rowData, true),
      withheldInvoiceAmt: calculateTotalSum('withheldInvoiceAmt', rowData),
      paidAmt: calculateTotalSum('paidAmt', rowData),
    });
  }
  return result;
};
export const colorCodeOnFieldsLevel = (colorCode, val, onFocus, disable) => {
  let className = '';
  if (parseFloat(val) < 0 && disable) {
    className = 'frr-color-red frr-color-class-grey';
  } else if (parseFloat(val) < 0 && !onFocus) {
    className = 'frr-color-red ';
  } else if (colorCode?.toString() === '12632256') {
    className = 'frr-color-class-grey';
  } else if (colorCode?.toString() === '11534335') {
    className = 'frr-color-class-yellow';
  } else if (colorCode?.toString() === '00b300') {
    className = 'frr-color-class-green ';
  }
  return className;
};

export const setErrorMessageForDiscrepancy = (val) => {
  let errorMsg = '';
  if (val?.toString() === 'RRA1') {
    errorMsg =
      'ROSI - Rebate Amount Paid is not equal to Units Paid * Current URA[RRA1].';
  } else if (val?.toString() === 'RRA2') {
    errorMsg =
      'ROSI - Rebate Amount Paid is not equal to Rebate Amount Invoiced + Invoice Correction Amount - Withheld Invoice Amount[RRA2].';
  } else if (val?.toString() === 'RACA') {
    errorMsg =
      'ROSI - Original URA was zero, but Adjustment Code A was used[RACA].';
  } else if (val?.toString() === 'RACB') {
    errorMsg =
      'ROSI - Original URA was not zero, but Adjustment Code B is present[RACB].';
  } else if (val?.toString() === 'RACC') {
    errorMsg =
      'ROSI - Number of Units Adjusted is not present, but Adjustment Code C is present[RACC].';
  } else if (val?.toString() === 'RDCW') {
    errorMsg =
      'ROSI - Labeler Disputed Units is not zero, but Adjustment Code W is present[RDCW].';
  } else if (val?.toString() === 'RICA') {
    errorMsg =
      'ROSI - Invoice Correction Amount is not equal to Units Invoiced + Adjusted Units * Current URA[RICA].';
  } else if (val?.toString() === 'RWIA') {
    errorMsg =
      'ROSI - Withheld Invoice Amount is not equal to Disputed Units * Current URA[RWIA].';
  } else if (val?.toString() === 'RCA0') {
    errorMsg =
      'Invoice Correction Amount = 0 and calculated Invoice Correction Amount > 0[RCA0].';
  } else if (val?.toString() === 'RNOB') {
    errorMsg =
      'ROSI - Original URA was zero and a new URA is present, but Adjustment Code B is not present[RNOB].';
  } else if (val?.toString() === 'RAUA') {
    errorMsg =
      'Adjusted URA is present and Original URA >0, no adjustment code A or I present[RAUA].';
  } else if (val?.toString() === 'RAAP') {
    errorMsg =
      'Adjusted URA is not present and A, B or I adjustment code is present[RAAP].';
  } else if (val?.toString() === 'RAUC') {
    errorMsg = 'Adjusted Units is present and no adjustment code C[RAUC].';
  } else if (val?.toString() === 'RMAC') {
    errorMsg =
      'ROSI - Adjusted URA or Adjusted Units present but not Adjustment Code[RMAC].';
  } else if (val?.toString() === 'RPAU') {
    errorMsg = 'Paid Amount > 0 and Paid Units = 0[RPAU].';
  } else if (val?.toString() === 'RMDC') {
    errorMsg =
      'ROSI - Labeler Disputed Units is not zero, but no Dispute Code is present[RMDC].';
  } else if (val?.toString() === 'RWA0') {
    errorMsg =
      'Withheld Invoice Amount = 0 and calculated Withheld Invoice  Amount > 0[RWA0].';
  } else if (val?.toString() === 'RMDU') {
    errorMsg =
      'ROSI - Original URA was not zero, modified URA is present, neither Adjustment Code A nor I is present[RMDU].';
  } else if (val?.toString() === 'RUPD') {
    errorMsg =
      'ROSI - Units Paid is not equal to Unit Invoiced + Adjusted Units - Disputed Units[RUPD].';
  }
  return errorMsg;
};
export const tabPressMoveNextColumn = (
  gridApi,
  columnName,
  rowIndex,
  nextCol
) => {
  _.debounce(() => {
    // console.log('ROSI-216');
    gridApi.api.ensureColumnVisible(columnName);
    gridApi.api.setFocusedCell(nextCol ? rowIndex : rowIndex + 1, columnName);
    gridApi.api.forEachNode(
      (node) =>
        node.rowIndex === (nextCol ? rowIndex : rowIndex + 1) &&
        node?.setSelected(true)
    );
  });
};
const handleCountDecimals = (amt) => {
  if (Math.floor(amt.valueOf()) === amt.valueOf()) return 0;
  return amt.toString()?.split('.')[1]?.length || 0;
};
export const CalculateAmountOwedNDC = (item) => {
  const unitInvoiced = parseFloat(item.totReimbursedUnits || 0);
  const unitAdjusted = parseFloat(item.adjustedUnits || 0);
  const URAAmt =
    parseFloat(item.adjustedUnitRebateAmt || 0) > 0
      ? parseFloat(item.adjustedUnitRebateAmt || 0).toFixed(6)
      : parseFloat(item.unitRebateAmt || 0).toFixed(6);
  const totalUnit = parseFloat(unitInvoiced) + parseFloat(unitAdjusted);
  const result = parseFloat(parseFloat(URAAmt) * parseFloat(totalUnit)).toFixed(
    2
  );
  return isNaN(result) ? parseFloat(0).toFixed(2) : result;
};

export const CalculateRebateAmountInvoice = (item) => {
  const unitInvoiced = parseFloat(item.totReimbursedUnits || 0);
  const originalURAAmount = parseFloat(item.unitRebateAmt || 0).toFixed(6);
  const result = roundOffAmt(
    parseFloat(originalURAAmount) * parseFloat(unitInvoiced)
  );
  return isNaN(result) ? parseFloat(0).toFixed(2) : result;
};

export const roundOffPaidAmount = (item) => {
  const originPaidAmt = parseFloat(replaceCommaIntoWhiteSpace(item.paidAmt));
  let paidAmt = 0;
  let length = 0;
  const paidUnits = parseFloat(item.paidUnits || 0);
  const originalURAAmount =
    parseFloat(item.adjustedUnitRebateAmt || 0) > 0
      ? parseFloat(item.adjustedUnitRebateAmt || 0)
      : parseFloat(item.unitRebateAmt || 0);
  length += handleCountDecimals(paidUnits);
  length += handleCountDecimals(originalURAAmount);
  paidAmt = parseFloat(originPaidAmt).toFixed(length);
  if (originPaidAmt === 0) {
    paidAmt = 0;
  }
  return paidAmt;
};
// round off amount
const roundOffAmt = (amount) => {
  const factor = 100;
  return amount < 0
    ? -Math.round(Math.abs(amount) * factor) / factor
    : Math.round(amount * factor) / factor;
};
// const roundOffAmt = (calCulatedAmount) => {
//   let roundedAmt = Math.round(calCulatedAmount * 10000) / 10000;
//   let roundedAmtValue = Math.round(roundedAmt * 100) / 100;
//   return roundedAmtValue;
// };
export const invoiceCorrectionAmount = (
  origUra, //ldbl_URA,
  origAdjUra, //ldbl_OrigURA
  adjustedUnits, //ldbl_AdjUnits
  totReimbursedUnits //ldbl_Units
) => {
  let invoiceCorrectionAmt;
  let invAmtCal;
  if (parseFloat(origUra) === parseFloat(origAdjUra)) {
    invAmtCal = parseFloat(origUra) * parseFloat(adjustedUnits || 0);
    invoiceCorrectionAmt = roundOffAmt(invAmtCal);
  } else if (adjustedUnits == 0) {
    invAmtCal =
      roundOffAmt(parseFloat(totReimbursedUnits) * parseFloat(origUra)) -
      roundOffAmt(parseFloat(totReimbursedUnits) * parseFloat(origAdjUra));
    invoiceCorrectionAmt = roundOffAmt(invAmtCal);
  } else {
    invAmtCal =
      roundOffAmt(
        (parseFloat(totReimbursedUnits) + parseFloat(adjustedUnits || 0)) *
          parseFloat(origUra)
      ) - roundOffAmt(parseFloat(totReimbursedUnits) * parseFloat(origAdjUra));
    invoiceCorrectionAmt = roundOffAmt(invAmtCal);
    // Round( ( Units + AdjUnits ) * URA, 2 ) - Round( Units * OrigURA, 2 )
  }
  return invoiceCorrectionAmt;
};
// export const amtOwedNdcFc = (
//   origUra, //ldbl_URA,
//   origAdjUra, //ldbl_OrigURA
//   adjustedUnits, //ldbl_AdjUnits
//   totReimbursedUnits //ldbl_Units
// ) => {
//   let amtOwedNdc;
//   if (adjustedUnits === null && origUra === null) {
//     //If adjusted Units and Adjusted URA is NULL,
//     amtOwedNdc = (
//       parseFloat(totReimbursedUnits) * parseFloat(origAdjUra)
//     ).toFixed(2); // Units Invoiced * URA
//   } else if (adjustedUnits != null && origUra === null) {
//     // If Adjusted Units is not NULL and Adjusted URA is NULL
//     amtOwedNdc = (
//       (parseFloat(totReimbursedUnits) + parseFloat(adjustedUnits)) *
//       parseFloat(origAdjUra)
//     ).toFixed(2); // (Units Invoiced + Adjusted Units) * URA
//   } else if (adjustedUnits === null && origUra != null) {
//     //If Adjusted Units is NULL and Adjusted URA is not Null
//     amtOwedNdc = (parseFloat(totReimbursedUnits) * parseFloat(origUra)).toFixed(
//       2
//     ); //Units Invoiced * Adjusted URA
//   } else {
//     //If Adjusted Units is not NULL and Adjusted URA is not Null
//     amtOwedNdc = (
//       (parseFloat(totReimbursedUnits) + parseFloat(adjustedUnits)) *
//       parseFloat(origUra)
//     ).toFixed(2); // (Units Invoiced + Adjusted Units) * Adjusted URA
//   }
//   return amtOwedNdc;
// };
export const roundOffInvoiceCorrectionAmt = (item) => {
  const originInvoiceCorrectionAmt = parseFloat(
    replaceCommaIntoWhiteSpace(item.invoiceCorrectionAmt)
  );
  let invoiceCorrectionAmt = 0;
  let length = 0;
  const ldbl_URA =
    parseFloat(item.adjustedUnitRebateAmt || 0) > 0
      ? parseFloat(item.adjustedUnitRebateAmt || 0)
      : parseFloat(item.unitRebateAmt || 0);
  const ldbl_OrigURA = parseFloat(item.unitRebateAmt || 0);
  const ldbl_AdjUnits = parseFloat(item.adjustedUnits || 0);
  const ldbl_Units = parseFloat(item.totReimbursedUnits || 0);
  if (parseFloat(ldbl_URA) === parseFloat(ldbl_OrigURA)) {
    length += handleCountDecimals(ldbl_URA);
    length += handleCountDecimals(ldbl_AdjUnits);
    invoiceCorrectionAmt = parseFloat(originInvoiceCorrectionAmt).toFixed(
      length
    );
  } else if (parseFloat(ldbl_AdjUnits) === 0) {
    length += handleCountDecimals(ldbl_Units);
    length += handleCountDecimals(ldbl_URA);
    length += handleCountDecimals(ldbl_OrigURA);
    invoiceCorrectionAmt = parseFloat(originInvoiceCorrectionAmt).toFixed(
      length
    );
  } else {
    length += handleCountDecimals(ldbl_Units);
    length += handleCountDecimals(ldbl_URA);
    length += handleCountDecimals(ldbl_OrigURA);
    length += handleCountDecimals(ldbl_AdjUnits);

    invoiceCorrectionAmt = parseFloat(originInvoiceCorrectionAmt).toFixed(
      length
    );
  }
  if (originInvoiceCorrectionAmt === 0) {
    invoiceCorrectionAmt = 0;
  }
  return invoiceCorrectionAmt;
};
export const roundOffWithheldInvcAmount = (item) => {
  const originWithheldInvoiceAmt = parseFloat(
    replaceCommaIntoWhiteSpace(item.withheldInvoiceAmt)
  );
  let withheldInvoiceAmt = 0;
  let length = 0;
  const ldbl_OrigURA = parseFloat(item.unitRebateAmt);
  const ldbl_Units = parseFloat(item.totReimbursedUnits);
  const ldbl_InvCorrAmt = parseFloat(item.invoiceCorrectionAmt);
  let ldbl_PaidAmt = parseFloat(item.paidAmt);
  length += handleCountDecimals(ldbl_OrigURA);
  length += handleCountDecimals(ldbl_Units);
  length += handleCountDecimals(ldbl_PaidAmt);
  length += handleCountDecimals(ldbl_InvCorrAmt);
  withheldInvoiceAmt = parseFloat(originWithheldInvoiceAmt).toFixed(length);
  if (originWithheldInvoiceAmt === 0) {
    withheldInvoiceAmt = 0;
  }
  return withheldInvoiceAmt;
};
export const disputedUnits = (totReimbursedUnits, adjustedUnits, paidUnits) => {
  const disputedUnit =
    parseFloat(totReimbursedUnits) +
    parseFloat(adjustedUnits || 0) -
    parseFloat(paidUnits).toFixed(3);
  return disputedUnit;
};
export const adjustedURA = (paidAmt, paidUnits) => {
  const origAdjUra = (parseFloat(paidAmt) / parseFloat(paidUnits)).toFixed(2);
  return origAdjUra;
};
export const paidUnitsCalculation = (
  totReimbursedUnits,
  adjustedUnits,
  disputedUnits
) => {
  const paidUnit = (
    parseFloat(totReimbursedUnits) +
    parseFloat(adjustedUnits || 0) -
    parseFloat(disputedUnits)
  ).toFixed(3);
  return paidUnit;
};
export const handlePaidInFull = (
  row,
  payIndicator,
  gridAllData,
  DuplicateGridData,
  handleSetDataWithTable,
  reconciliationNumber,
  dispatchROSIGridListEmpty,
  isRecordModified
) => {
  const lsNull = '-1';
  const ldblNull = 0;
  let updateRow = { ...row };
  let newObj = [];

  if (payIndicator) {
    newObj = gridAllData.map((item, rowIndex) => {
      if (item.id === row.id) {
        if (
          item?.invRecSeqNum === reconciliationNumber ||
          parseInt(item.invRecSeqNum, [0, 1]) === 0
        ) {
          item.bgColorForPaidInFullInd = '';
        } else {
          item.bgColorForPaidInFullInd =
            item.dqdStatsCd === 'WO' ||
            item.dqdStatsCd === 'FG' ||
            item.dqdStatsCd === 'DB' ||
            item.dqdStatsCd === 'DBK'
              ? '00b300'
              : '12632256';
        }
        if (
          parseFloat(item?.ccOverrideColorDis) >= 0 ||
          item.dqdStatsCd === 'WO' ||
          item.dqdStatsCd === 'FG' ||
          item.dqdStatsCd === 'DB' ||
          item.dqdStatsCd === 'DBK'
        ) {
          item.bgColorForInterestCalc = '00b300';
        } else {
          item.bgColorForInterestCalc = '12632256';
        }

        if (
          item.invRecSeqNum === reconciliationNumber ||
          parseInt(item.invRecSeqNum, [0, 1]) === 0
        ) {
          if (
            parseFloat(item?.ccOverrideColorDis) >= 0 ||
            item.dqdStatsCd === 'WO' ||
            item.dqdStatsCd === 'FG' ||
            item.dqdStatsCd === 'DB' ||
            item.dqdStatsCd === 'DBK'
          ) {
            item.bgColorForNDC = '00b300'; // Green color
            item.bgColor = '00b300';
          } else {
            item.bgColorForNDC = '12632256'; // Grey color
            item.bgColor = '12632256';
          }
        } else {
          item.bgColorForNDC = '11534335'; // yellow color
          item.bgColor = '11534335';
        }
        if (
          parseFloat(item?.ccOverrideColorDis) >= 0 ||
          item.dqdStatsCd === 'WO' ||
          item.dqdStatsCd === 'FG' ||
          item.dqdStatsCd === 'DB' ||
          item.dqdStatsCd === 'DBK'
        ) {
          item.bgColorForURA = '00b300'; // Green color
        } else {
          item.bgColorForURA = '12632256'; // Grey color
        }
        if (
          item.invRecSeqNum === reconciliationNumber ||
          parseInt(item.invRecSeqNum, [0, 1]) === 0
        ) {
          if (parseInt(item.ccPaidInFullInd, [0, 1]) === 1) {
            if (
              parseFloat(item?.ccOverrideColorDis) >= 0 ||
              item.dqdStatsCd === 'WO' ||
              item.dqdStatsCd === 'FG' ||
              item.dqdStatsCd === 'DB' ||
              item.dqdStatsCd === 'DBK'
            ) {
              item.bgColorForAdjustedURA = '00b300'; // Green color
              item.bgColorForUnitsAdjustment = '00b300';
              item.bgColorForDisputedUnits = '00b300';
              item.bgColorForUnitsPaid = '00b300';
              item.bgColorForCcAc1 = '00b300';
              item.bgColorForCcAc2 = '00b300';
              item.bgColorForCcAc3 = '00b300';
              item.bgColorForCcDc1 = '00b300';
              item.bgColorForCcDc2 = '00b300';
              item.bgColorForCcDc3 = '00b300';
              item.bgColorForInvoiceCorrectionAmt = '00b300';
              item.bgColorForWithheldInvoiceAmt = '00b300';
              item.bgColorForPaidAmt = '00b300';
            } else {
              item.bgColorForAdjustedURA = '12632256';
              item.bgColorForUnitsAdjustment = '12632256';
              item.bgColorForDisputedUnits = '12632256';
              item.bgColorForUnitsPaid = '12632256';
              item.bgColorForCcAc1 = '12632256';
              item.bgColorForCcAc2 = '12632256';
              item.bgColorForCcAc3 = '12632256';
              item.bgColorForCcDc1 = '12632256';
              item.bgColorForCcDc2 = '12632256';
              item.bgColorForCcDc3 = '12632256';
              item.bgColorForInvoiceCorrectionAmt = '12632256';
              item.bgColorForWithheldInvoiceAmt = '12632256';
              item.bgColorForPaidAmt = '12632256';
            }
          } else if (parseFloat(item?.ccOverrideColorDis) >= 0) {
            item.bgColorForAdjustedURA = '00b300'; // Green color
            item.bgColorForUnitsAdjustment = '00b300';
            item.bgColorForDisputedUnits = '00b300';
            item.bgColorForUnitsPaid = '00b300';
            item.bgColorForCcAc1 = '00b300';
            item.bgColorForCcAc2 = '00b300';
            item.bgColorForCcAc3 = '00b300';
            item.bgColorForCcDc1 = '00b300';
            item.bgColorForCcDc2 = '00b300';
            item.bgColorForCcDc3 = '00b300';
            item.bgColorForInvoiceCorrectionAmt = '00b300';
            item.bgColorForWithheldInvoiceAmt = '00b300';
            item.bgColorForPaidAmt = '00b300';
          } else {
            item.bgColorForAdjustedURA = '';
            item.bgColorForUnitsAdjustment = '';
            item.bgColorForDisputedUnits = '';
            item.bgColorForUnitsPaid = '';
            item.bgColorForCcAc1 = '';
            item.bgColorForCcAc2 = '';
            item.bgColorForCcAc3 = '';
            item.bgColorForCcDc1 = '';
            item.bgColorForCcDc2 = '';
            item.bgColorForCcDc3 = '';
            item.bgColorForInvoiceCorrectionAmt = '';
            item.bgColorForWithheldInvoiceAmt = '';
            item.bgColorForPaidAmt = '';
          }
        } else if (
          parseFloat(item?.ccOverrideColorDis) >= 0 ||
          item.dqdStatsCd === 'WO' ||
          item.dqdStatsCd === 'FG' ||
          item.dqdStatsCd === 'DB' ||
          item.dqdStatsCd === 'DBK'
        ) {
          item.bgColorForAdjustedURA = '00b300'; // Green color
          item.bgColorForUnitsAdjustment = '00b300';
          item.bgColorForDisputedUnits = '00b300';
          item.bgColorForUnitsPaid = '00b300';
          item.bgColorForCcAc1 = '00b300';
          item.bgColorForCcAc2 = '00b300';
          item.bgColorForCcAc3 = '00b300';
          item.bgColorForCcDc1 = '00b300';
          item.bgColorForCcDc2 = '00b300';
          item.bgColorForCcDc3 = '00b300';
          item.bgColorForInvoiceCorrectionAmt = '00b300';
          item.bgColorForWithheldInvoiceAmt = '00b300';
          item.bgColorForPaidAmt = '00b300';
        } else {
          item.bgColorForAdjustedURA = '12632256'; // Grey color
          item.bgColorForUnitsAdjustment = '12632256';
          item.bgColorForDisputedUnits = '12632256';
          item.bgColorForUnitsPaid = '12632256';
          item.bgColorForCcAc1 = '12632256';
          item.bgColorForCcAc2 = '12632256';
          item.bgColorForCcAc3 = '12632256';
          item.bgColorForCcDc1 = '12632256';
          item.bgColorForCcDc2 = '12632256';
          item.bgColorForCcDc3 = '12632256';
          item.bgColorForInvoiceCorrectionAmt = '12632256';
          item.bgColorForWithheldInvoiceAmt = '12632256';
          item.bgColorForPaidAmt = '12632256';
        }

        if (
          parseFloat(item?.ccOverrideColorDis) >= 0 ||
          item.dqdStatsCd === 'WO' ||
          item.dqdStatsCd === 'FG' ||
          item.dqdStatsCd === 'DB' ||
          item.dqdStatsCd === 'DBK'
        ) {
          item.bgColorForUnitInvoiced = '00b300'; // Green color
          item.bgColorForrebateAmtInvoice = '00b300';
        } else {
          item.bgColorForUnitInvoiced = '12632256'; // Grey color
          item.bgColorForrebateAmtInvoice = '12632256';
        }
        if (item.drugSeqNum === newObj[rowIndex - 1]?.drugSeqNum) {
          if (
            parseFloat(item?.ccOverrideColorDis) >= 0 ||
            item.dqdStatsCd === 'WO' ||
            item.dqdStatsCd === 'FG' ||
            item.dqdStatsCd === 'DB' ||
            item.dqdStatsCd === 'DBK'
          ) {
            item.bgColorForAmtOwedNDC = '00b300';
          } else {
            item.bgColorForAmtOwedNDC = '12632256';
          }
        } else if (
          parseFloat(item?.ccOverrideColorDis) >= 0 ||
          item.dqdStatsCd === 'WO' ||
          item.dqdStatsCd === 'FG' ||
          item.dqdStatsCd === 'DB' ||
          item.dqdStatsCd === 'DBK'
        ) {
          item.bgColorForAmtOwedNDC = '00b300';
        } else {
          item.bgColorForAmtOwedNDC = '12632256';
        }
        item.originStatus = item.statusCd;
        item.statusCd = 'PIF';
        // item.rosi_drug_status_cd= 'PIF';
        item.roiDrugStatusDt = moment().format('YYYY/MM/DD');
        item.paidUnits = item.totReimbursedUnits;
        item.paidAmt = item.rebateAmtInvoice;
        item.isAdjustedUnitsUpdated = false;
        //if (item?.adjustedUnitRebateAmtUpdate) {
        item.amountOwedNdc = item.rebateAmtInvoice;
        //}
        item.invoiceCorrectionAmt = 0;
        item.withheldInvoiceAmt = 0;
        item.ccAc1 = lsNull;
        item.ccAc2 = lsNull;
        item.ccAc3 = lsNull;
        item.ccDc1 = lsNull;
        item.ccDc2 = lsNull;
        item.ccDc3 = lsNull;
        item.adjustedUnitRebateAmt = '';
        item.adjustedUnits = '';
        item.disputedUnits = ldblNull;
        item.colDetails = {};
        return item;
      }
      return item;
    });
  } else {
    newObj = gridAllData;
    DuplicateGridData.forEach((val) => {
      if (val.id === row?.id) {
        const index = newObj.findIndex((x) => {
          return x.id === row.id;
        });

        const Obj = {
          ...val,
          paidFulAmt: null,
          addEditRow: isRecordModified ? true : false,
          ccPaidInFullInd: 0,
          ccInterestAllocated: row?.ccInterestAllocated,
          interestSettledInd: row?.interestSettledInd,
          isRecordModifiedOrNew: isRecordModified ? true : false,
          discrepancyAlert: isRecordModified ? true : false,
          statusCd: '',
          disputedUnits: 0,
          paidUnits: 0,
          paidAmt: 0,
          invoiceCorrectionAmt: 0,
          withheldInvoiceAmt: 0,
          roiDrugStatusDt: moment().format('YYYY/MM/DD'),
          ccCommentsExist: newObj[index].ccCommentsExist,
          ndc: newObj[index].ndc?.toString()?.replace('/ndc00', '').trim(),
        };
        newObj[index] = Obj;
        updateRow = Obj;
      }
    });
    if (dispatchROSIGridListEmpty) {
      dispatchROSIGridListEmpty();
    }
  }
  if (payIndicator) {
    handleSetDataWithTable(newObj);
  } else {
    handleSetDataWithTable(
      newObj,
      constantMessageData.UPDATE_STATE_FOR_ROSI_DATA
    );
  }
  return updateRow;
};
// ue_Recalc():  function

export const handleSummaryRecall = (
  ROSIGridRowData,
  allocatePaymentHeaderDetail,
  summaryGirdRowData,
  summaryGirdAllData,
  dispatch,
  activeInvNum,
  activeCheckLogNum,
  setSummaryRowData,
  summaryGridParams,
  setCallSumOfInterestPaid,
  callSumOfInterestPaid
) => {
  let interestObj = 0;
  let Prin = 0;
  let otherInterest = 0;
  const temp = [...summaryGirdRowData];
  ROSIGridRowData?.length > 0 &&
    ROSIGridRowData.forEach((val) => {
      let OneMod = false;
      let IntMod = false;
      if (
        parseInt(val.invRecSeqNum) ==
          parseInt(allocatePaymentHeaderDetail?.reconciliationNumber) ||
        val.invRecSeqNum === 0 ||
        ROSIGridRowData?.filter((x) => {
          return x.updateInRow;
        }).length > 0
      ) {
        let ldbltemp = val.ccInterestAllocated;
        if (parseFloat(ldbltemp)) {
          interestObj += parseFloat(ldbltemp);
        }
        ldbltemp = parseFloat(val?.paidAmt);
        if (
          parseInt(val.invRecSeqNum) ===
            parseInt(allocatePaymentHeaderDetail?.reconciliationNumber) ||
          val.invRecSeqNum === 0
        ) {
          OneMod = true;
        }
        if (val?.interestUpdate || val?.newlyInserted) {
          IntMod = true;
        } else if (val.modifiedValues || val.newlyInserted) {
          OneMod = true;
        }
        if (OneMod && parseFloat(ldbltemp)) {
          Prin += parseFloat(ldbltemp);
        }
      }
      return val;
    });
  let result = null;
  if (
    !callSumOfInterestPaid ||
    callSumOfInterestPaid?.payload?.invRecSeqNum !=
      allocatePaymentHeaderDetail?.reconciliationNumber ||
    callSumOfInterestPaid?.payload?.invoiceNum !=
      allocatePaymentHeaderDetail?.invoiceNum
  ) {
    result = SumOfInterest({
      invRecSeqNum: allocatePaymentHeaderDetail?.reconciliationNumber,
      rosiQtr: handleQuarterFormate(allocatePaymentHeaderDetail?.qtr),
      invoiceNum: allocatePaymentHeaderDetail?.invoiceNum,
    });
    setCallSumOfInterestPaid({
      payload: {
        invRecSeqNum: allocatePaymentHeaderDetail?.reconciliationNumber,
        rosiQtr: handleQuarterFormate(allocatePaymentHeaderDetail?.qtr),
        invoiceNum: allocatePaymentHeaderDetail?.invoiceNum,
      },
      res: result,
    });
  } else if (callSumOfInterestPaid?.res) {
    result = callSumOfInterestPaid?.res;
  }
  result
    .then((res) => {
      otherInterest = res;
    })
    .catch(() => {
      otherInterest = 0;
    });

  if (!parseFloat(otherInterest)) otherInterest = 0;
  let newIntStld = calculateTotalSum('ccInterestOwed', ROSIGridRowData)
    ?.toString()
    ?.replace(',', '')
    .trim();
  const newTotPrin = calculateTotalSum('paidAmt', ROSIGridRowData)
    ?.toString()
    ?.replace(',', '')
    .trim();

  let newOwedAmt = calculateTotalSum('amountOwedNdc', ROSIGridRowData, true)
    ?.toString()
    ?.replace(',', '')
    .trim();
  if (!parseFloat(newIntStld)) newIntStld = 0;
  if (!parseFloat(newOwedAmt)) newOwedAmt = 0;
  // if (parseFloat(interestObj)) {
  if (!ROSIGridRowData[0]?.disabledForInterestAllocated) {
    temp[0].intPaid =
      parseFloat(interestObj) != 0
        ? parseFloat(interestObj).toFixed(2)
        : temp[0].intPaid;
    if (
      parseFloat(temp[0]?.originalAmtIntPaid) != 0 &&
      parseFloat(interestObj) != 0
    ) {
      temp[0].intPaid = parseFloat(
        parseFloat(interestObj) + parseFloat(temp[0]?.originalAmtIntPaid)
      );
    }
  }

  // } // interest paid this chk
  // else {
  //   interestObj = parseFloat(summaryGirdRowData[0].intPaid).toFixed(2);
  // }
  if (!parseFloat(interestObj)) interestObj = 0;
  temp[0].currentPrincipalAmount = `$ ${parseFloat(
    newOwedAmt?.toString()?.replace(',', '').trim()
  )?.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
  temp[0].principalPaid = `$ ${parseFloat(
    Prin?.toString()?.replace(',', '').trim()
  )?.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
  temp[0].totalPrincipalPaid = `$ ${parseFloat(
    newTotPrin?.toString()?.replace(',', '').trim()
  )?.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

  temp[0].totalInterestCalc = `$ ${parseFloat(
    newIntStld?.toString()?.replace(',', '').trim()
  )?.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
  // totalIntPaid logic when Int.Paid change in row level
  const newIntPaidThisCheck =
    parseFloat(
      removeDollarForNumberFiled(removeCommaForNumberFiled(temp[0].intPaid))
        ?.toString()
        ?.trim()
    ) || 0;
  const oldTotalIntPaid =
    parseFloat(
      removeDollarForNumberFiled(
        removeCommaForNumberFiled(temp[0].originalTotalIntPaid)
      )
        ?.toString()
        ?.trim()
    ) || 0;
  const oldIntPaidThisCheck =
    parseFloat(
      removeDollarForNumberFiled(
        removeCommaForNumberFiled(temp[0].originalAmtIntPaid)
      )
        ?.toString()
        ?.trim()
    ) || 0;
  const newTotalIntPaid =
    oldTotalIntPaid - oldIntPaidThisCheck + newIntPaidThisCheck;
  // end
  temp[0].totalIntPaid = `$ ${(
    parseFloat(
      removeDollarForNumberFiled(
        removeCommaForNumberFiled(newTotalIntPaid)
      )?.trim()
    ) + parseFloat(removeCommaForNumberFiled(otherInterest).trim())
  )?.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
  temp[0].addEditRow = true;
  temp[0].totalIntPaidAmt = (
    parseFloat(otherInterest?.toString()?.replace(',', '').trim()) +
    summaryGirdRowData[0]?.addEditIntPaid
      ? parseFloat(interestObj?.toString()?.replace(',', '').trim())
      : 0
  )?.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  setSummaryRowData([]);
  setSummaryRowData(temp);
  summaryGirdAllData[`${activeInvNum}-${activeCheckLogNum}`] = temp;
  dispatch(dispatchSummaryGridList(summaryGirdAllData));
  if (summaryGridParams?.api) {
    _.debounce(() => {
      // console.log('ROSI-881');
      summaryGridParams.api.refreshCells({ force: true });
    });
  }
};

export const checksGridTableHead = [
  {
    headerName: 'Check Log Number',
    field: 'checkLogNum',
    sort: 'asc',
    editable: false,
    sortable: true,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    excelAlignment: 'right',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'CCN',
    field: 'checkIdentifier',
    editable: false,
    sortable: true,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    comparator: numberAndTextComparator,
    cellClass: 'frr-ellipsis-text',
    cellRenderer: 'NameRenderCheckIdentifier',

    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Batch Number',
    field: 'batchNum',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    comparator: numberAndTextComparator,
    cellRenderer: 'NameRenderBatchNum',
    cellClass: 'frr-ellipsis-text',

    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Batch Date',
    field: 'batchDt',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_130,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Check Number',
    field: 'checkNum',
    editable: false,
    sortable: true,
    autoHeight: true,
    wrapText: true,
    minWidth: Styles.Width_180,
    comparator: numberAndTextComparator,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Check Issuer',
    field: 'checkIssuer',
    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 3,
    minWidth: Styles.Width_280,
    comparator: numberAndTextComparator,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'NameRenderCheckIssuer',
    comparator: NumberAndAlphabetComparator,
    cellClass: 'frr-ellipsis-text',

    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Information',
    field: 'checkInfo',
    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 3,
    minWidth: Styles.Width_200,
    comparator: numberAndTextComparator,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'NameRenderInformation',
    cellClass: 'frr-ellipsis-text',

    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Check Date',
    field: 'checkDt',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_130,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Postmark Date',
    field: 'postmarkedDt',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Received Date',
    field: 'receivedDt',
    comparator: dateComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Check Amt',
    field: 'checkAmt',
    comparator: amountComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    isTextColorRed: true,
    autoHeight: true,
    wrapText: true,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'CheckAmtCellRender',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Allocated Amt',
    field: 'totAllocatedAmt',
    comparator: amountComparator,
    editable: false,
    sortable: true,
    suppressMenu: false,
    isTextColorRed: true,
    autoHeight: true,
    wrapText: true,
    minWidth: Styles.Width_210,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'TotAllocatedAmtCellRender',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Format',
    field: 'invRecFormatCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_120,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Dispute Resolution',
    field: 'disputeResolutionCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    autoHeight: true,
    wrapText: true,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Check Payee',
    field: 'checkPayeeCd',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: false,
    autoHeight: true,
    wrapText: true,
    minWidth: Styles.Width_160,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
export const manuFactureHead = [
  {
    headerName: 'Manufacturer ID',
    field: 'mfgId',
    sort: 'asc',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    cellStyle: { 'border-right-color': Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Manufacturer Name',
    field: 'mfgName',
    editable: false,
    sortable: true,
    resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'RenderMFGName',
    cellClass: 'frr-ellipsis-text',

    cellStyle: { 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
export const ROSIGRidTableHead = [
  {
    headerName: 'Comments Exists',
    field: 'ccCommentsExist',
    filter: false,
    sortable: false,
    enableMenu: false,
    showCheckboxIcon: true,
    minWidth: Styles.Width_158,
    maxWidth: Styles.Width_180,
    resizable: true,
    editable: false,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'ActionCellRender',
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
  },
  {
    headerName: 'Paid In Full',
    field: 'ccPaidInFullInd',
    editable: false,
    sortable: false,
    minWidth: Styles.Width_100,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    hideFilterIcon: true,
    showCheckboxIcon: true,
    cellRenderer: 'PaidInFullCheckBoxRender',
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
    fillBackgroundColorCol: 'bgColorForPaidInFullInd',
    showBackgroundColor: true,
  },
  {
    headerName: 'Interest Settled',
    field: 'interestSettledInd',
    editable: false,
    sortable: false,
    minWidth: Styles.Width_100,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    hideFilterIcon: true,
    showCheckboxIcon: true,
    cellRenderer: 'InterestSettledCheckBoxRender',
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
  },
  {
    headerName: 'Int. Calc',
    field: 'ccInterestOwed',
    cellClass: '',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    isTextColorRed: true,
    printPrefixValue: '$ ',
    cellRenderer: 'InterestCalCellRender',
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    isBgColor: true,
    bgColorName: 'bgColorForInterestCalc',
    exportZeroesTwo: true,
  },
  {
    headerName: 'Int. Paid',
    field: 'ccInterestAllocated',
    cellClass: '',
    editable: false,
    sortable: true,
    suppressMenu: false,
    isTextColorRed: true,
    printPrefixValue: '$ ',
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'InterestPaidCellRender',
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    exportZeroesTwo: true,
    suppressKeyboardEvent: (params) => {
      const rowIndex = params.node.rowIndex;
      const e = params.event;
      const api = params.api;
      if (e.shiftKey && e.key === 'Tab') {
        const colNameDP = 'interestSettledInd';
        const timeId = setTimeout(() => {
          // console.log('ROSI-1451');
          // Move focus
          api.setFocusedCell(rowIndex, colNameDP);
          // FORCE SCROLL (horizontal + vertical)
          api.ensureIndexVisible(rowIndex);
          api.ensureColumnVisible(colNameDP);
          clearTimeout(timeId);
        }, 1000);
      } else if (!e.shiftKey && e.key === 'Tab') {
        const colNameDP = 'adjustedUnitRebateAmt';
        const timeId = setTimeout(() => {
          // console.log('ROSI-1462');
          // Move focus
          api.setFocusedCell(rowIndex, colNameDP);
          // FORCE SCROLL (horizontal + vertical)
          api.ensureIndexVisible(rowIndex);
          api.ensureColumnVisible(colNameDP);
          const nextElement = document.getElementById(
            `${colNameDP}${rowIndex}`
          );
          if (nextElement) {
            nextElement.focus();
            nextElement.select();
          }
          clearTimeout(timeId);
        }, 1000);
      }
    },
  },
  {
    headerName: 'NDC',
    field: 'ndc',
    sort: 'asc',
    editable: false,
    sortable: true,
    suppressMenu: false,
    removeWhiteSpaceForNDC: true,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'NDCCellRender',
    cellStyle: (params) => {
      if (params.data?.bgColorForNDC?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColorForNDC?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterValueGetter: (params) => {
      if (params.data?.isBottomRow) return '';
      return removeWhiteSpaceForNDC(params.data?.ndc) ?? '';
    },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher: ndcTextMatcher,
    },
    isBgColor: true,
    bgColorName: 'bgColorForNDC',
  },
  {
    headerName: 'Drug Name',
    field: 'drugName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 3,
    minWidth: Styles.Width_171,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'DrugNameCellRender',
    cellStyle: (params) => {
      if (params.data?.bgColorForNDC?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColorForNDC?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    isBgColor: true,
    bgColorName: 'bgColorForNDC',
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'URA',
    field: 'unitRebateAmt',
    comparator: amountComparator,
    cellClass: 'frr-input-width',
    editable: false,
    sortable: true,
    suppressMenu: false,
    isBgColor: true,
    dataAlignRight: true,
    isTextColorRed: true,
    bgColorName: 'bgColorForURA',
    excelAlignment: 'right',
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'URACellRender',
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Adjusted URA',
    field: 'adjustedUnitRebateAmt',
    comparator: amountComparator,
    cellClass: 'frr-input-width-93per',
    editable: false,
    sortable: true,
    suppressMenu: false,
    minWidth: Styles.Width_190,
    printPrefixValue: ' ',
    exportZeroSix: true,
    isBgColor: true,
    isTextColorRed: true,
    dataAlignRight: true,
    bgColorName: 'bgColorForAdjustedURA',
    excelAlignment: 'right',
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'AdjustedURACellRender',
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
    sortingOrder: ['desc', 'asc'],
    pdfExportOptions:{
      showTotalsLabel: true,
    },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    suppressKeyboardEvent: (params) => {
      const rowIndex = params.node.rowIndex;
      const e = params.event;
      const api = params.api;
      if (e.shiftKey && e.key === 'Tab') {
        const colNameDP = 'ccInterestAllocated';
        const timeId = setTimeout(() => {
          // console.log('ROSI-1660');
          // Move focus
          api.setFocusedCell(rowIndex, colNameDP);
          // FORCE SCROLL (horizontal + vertical)
          api.ensureIndexVisible(rowIndex);
          api.ensureColumnVisible(colNameDP);
          const nextElement = document.getElementById(
            `${colNameDP}${rowIndex}`
          );
          if (nextElement) {
            nextElement.focus();
            nextElement.select();
          }
          clearTimeout(timeId);
        }, 1000);
      } else if (!e.shiftKey && e.key === 'Tab') {
        const colNameDP = 'adjustedUnits';
        const timeId = setTimeout(() => {
          // console.log('ROSI-1678');
          // Move focus
          api.setFocusedCell(rowIndex, colNameDP);
          // FORCE SCROLL (horizontal + vertical)
          api.ensureIndexVisible(rowIndex);
          api.ensureColumnVisible(colNameDP);
          const nextElement = document.getElementById(
            `${colNameDP}${rowIndex}`
          );
          if (nextElement) {
            nextElement.focus();
            nextElement.select();
          }
          clearTimeout(timeId);
        }, 1000);
      }
    },
  },
  {
    headerName: 'Units Invoiced',
    field: 'totReimbursedUnits',
    comparator: amountComparator,
    cellClass: 'frr-input-width',
    editable: false,
    sortable: true,
    suppressMenu: false,
    isBgColor: true,
    dataAlignRight: true,
    isTextColorRed: true,
    bgColorName: 'bgColorForUnitInvoiced',
    excelAlignment: 'right',
    minWidth: Styles.Width_190,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'UnitsInvoicedCellRender',
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
    sortingOrder: ['desc', 'asc'],
    exportZeroesThree: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Units Adjustment',
    field: 'adjustedUnits',
    comparator: amountComparator,
    cellClass: 'frr-input-width',
    editable: false,
    sortable: true,
    suppressMenu: false,
    isBgColor: true,
    dataAlignRight: true,
    isTextColorRed: true,
    bgColorName: 'bgColorForUnitsAdjustment',
    excelAlignment: 'right',
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'UnitsAdjustmentCellRender',
    suppressKeyboardEvent: (params) => {
      const rowIndex = params.node.rowIndex;
      const e = params.event;
      const api = params.api;
      const colName = 'disputedUnits';
      if (!e.shiftKey && e.key === 'Tab') {
        requestAnimationFrame(() => {
          // console.log('ROSI-1760');
          // Move focus
          api.setFocusedCell(rowIndex, colName);
          // FORCE SCROLL (horizontal + vertical)
          api.ensureIndexVisible(rowIndex);
          api.ensureColumnVisible(colName);
          const nextElement = document.getElementById(`${colName}${rowIndex}`);
          if (nextElement) {
            nextElement.select();
            nextElement.focus();
          }
        });
      } else if (e.shiftKey && e.key === 'Tab') {
        const colNameDP = 'adjustedUnitRebateAmt';
        const timeId = setTimeout(() => {
          // console.log('ROSI-1775');
          // Move focus
          api.setFocusedCell(rowIndex, colNameDP);
          // FORCE SCROLL (horizontal + vertical)
          api.ensureIndexVisible(rowIndex);
          api.ensureColumnVisible(colNameDP);
          const nextElement = document.getElementById(
            `${colNameDP}${rowIndex}`
          );
          if (nextElement) {
            nextElement.focus();
            nextElement.select();
          }
          clearTimeout(timeId);
        }, 1000);
      }
    },
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
    sortingOrder: ['desc', 'asc'],
    exportZeroesThree: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Disputed Units',
    field: 'disputedUnits',
    comparator: amountComparator,
    cellClass: 'frr-input-width',
    editable: false,
    sortable: true,
    suppressMenu: false,
    isBgColor: true,
    dataAlignRight: true,
    isTextColorRed: true,
    bgColorName: 'bgColorForDisputedUnits',
    excelAlignment: 'right',
    minWidth: Styles.Width_190,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'DisputedUnitsCellRender',
    suppressKeyboardEvent: (params) => {
      const rowIndex = params.node.rowIndex;
      const e = params.event;
      const api = params.api;
      const colName = 'paidUnits';
      if (!e.shiftKey && e.key === 'Tab') {
        requestAnimationFrame(() => {
          // console.log('ROSI-1840');
          // Move focus
          api.setFocusedCell(rowIndex, colName);
          // FORCE SCROLL (horizontal + vertical)
          api.ensureIndexVisible(rowIndex);
          api.ensureColumnVisible(colName);
          const nextElement = document.getElementById(`${colName}${rowIndex}`);
          if (nextElement) {
            nextElement.select();
            nextElement.focus();
          }
        });
      } else if (e.shiftKey && e.key === 'Tab') {
        const colNameDP = 'adjustedUnits';
        const timeId = setTimeout(() => {
          // console.log('ROSI-1855');
          // Move focus
          api.setFocusedCell(rowIndex, colNameDP);
          // FORCE SCROLL (horizontal + vertical)
          api.ensureIndexVisible(rowIndex);
          api.ensureColumnVisible(colNameDP);
          const nextElement = document.getElementById(
            `${colNameDP}${rowIndex}`
          );
          if (nextElement) {
            nextElement.focus();
            nextElement.select();
          }
          clearTimeout(timeId);
        }, 1000);
      }
    },
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
    sortingOrder: ['desc', 'asc'],
    exportZeroesThree: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Units Paid',
    field: 'paidUnits',
    comparator: amountComparator,
    cellClass: 'frr-input-width',
    editable: false,
    sortable: true,
    suppressMenu: false,
    isBgColor: true,
    dataAlignRight: true,
    isTextColorRed: true,
    bgColorName: 'bgColorForUnitsPaid',
    excelAlignment: 'right',
    minWidth: Styles.Width_190,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'PaidUnitsCellRender',
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
    sortingOrder: ['desc', 'asc'],
    exportZeroesThree: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    suppressKeyboardEvent: (params) => {
      const key = params.event.key;
      const e = params.event;
      const rowIndex = params.node.rowIndex;
      const api = params.api;
      const colName = 'ccAc1';
      if (key === 'ArrowDown' || key === 'ArrowUp' || key === 'Enter') {
        const inputId = `${params?.column?.colId}${
          key === 'ArrowDown' || key === 'Enter' ? rowIndex + 1 : rowIndex - 1
        }`;
        // debounce
        const timeId = setTimeout(() => {
          const input = document?.getElementById(inputId);
          if (input) {
            input.focus();
            input.select();
          }
          clearTimeout(timeId);
        }, 10);
        params.context.dispatch(dispatchColIdForRosi(inputId));
      }
      if (!e.shiftKey && key === 'Tab') {
        requestAnimationFrame(() => {
          // console.log('ROSI-1960');
          // Move focus
          api.setFocusedCell(rowIndex, colName);
          // FORCE SCROLL (horizontal + vertical)
          api.ensureIndexVisible(rowIndex);
          api.ensureColumnVisible(colName);
          const nextElement = document.getElementById(`${colName}${rowIndex}`);
          if (nextElement) {
            nextElement.focus();
          }
        });
      } else if (e.shiftKey && e.key === 'Tab') {
        const colNameDP = 'disputedUnits';
        const timeId = setTimeout(() => {
          // console.log('ROSI-1974');
          // Move focus
          api.setFocusedCell(rowIndex, colNameDP);
          // FORCE SCROLL (horizontal + vertical)
          api.ensureIndexVisible(rowIndex);
          api.ensureColumnVisible(colNameDP);
          const nextElement = document.getElementById(
            `${colNameDP}${rowIndex}`
          );
          if (nextElement) {
            nextElement.select();
            nextElement.focus();
          }
          clearTimeout(timeId);
        }, 1000);
      }
    },
  },
  {
    headerName: 'Adj Code 1',
    field: 'ccAc1',
    editable: false,
    sortable: true,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    columnSpan: 2,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'AdjCode1CellRender',
    // showDropDownVal: true,
    isBgColor: true,
    bgColorName: 'bgColorForCcAc1',
    // dropDownValueCol: 'ccAc1ValWithLabel',
    valueGetter: getAdjDisputeExportValue('ccAc1ValWithLabel'),
    valueSetter: adjDisputeValueSetter,
    filterValueGetter: getAdjDisputeFilterValue('ccAc1'),
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Adj Code 2',
    field: 'ccAc2',
    editable: false,
    sortable: true,
    suppressMenu: false,
    wrapHeaderText: true,
    columnSpan: 2,
    autoHeaderHeight: true,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'AdjCode2CellRender',
    // showDropDownVal: true,
    isBgColor: true,
    bgColorName: 'bgColorForCcAc2',
    // dropDownValueCol: 'ccAc2ValWithLabel',
    valueGetter: getAdjDisputeExportValue('ccAc2ValWithLabel'),
    valueSetter: adjDisputeValueSetter,
    filterValueGetter: getAdjDisputeFilterValue('ccAc2'),
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }

      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Adj Code 3',
    field: 'ccAc3',
    editable: false,
    sortable: true,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    columnSpan: 2,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'AdjCode3CellRender',
    // showDropDownVal: true,
    isBgColor: true,
    bgColorName: 'bgColorForCcAc3',
    // dropDownValueCol: 'ccAc3ValWithLabel',
    valueGetter: getAdjDisputeExportValue('ccAc3ValWithLabel'),
    valueSetter: adjDisputeValueSetter,
    filterValueGetter: getAdjDisputeFilterValue('ccAc3'),
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Dispute Code 1',
    field: 'ccDc1',
    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 2,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'DisputeCode1CellRender',
    // showDropDownVal: true,
    isBgColor: true,
    bgColorName: 'bgColorForCcDc1',
    // dropDownValueCol: 'ccDc1ValWithLabel',
    valueGetter: getAdjDisputeExportValue('ccDc1ValWithLabel'),
    valueSetter: adjDisputeValueSetter,
    filterValueGetter: getAdjDisputeFilterValue('ccDc1'),
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Dispute Code 2',
    field: 'ccDc2',
    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 2,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'DisputeCode2CellRender',
    // showDropDownVal: true,
    isBgColor: true,
    bgColorName: 'bgColorForCcDc2',
    // dropDownValueCol: 'ccDc2ValWithLabel',
    valueGetter: getAdjDisputeExportValue('ccDc2ValWithLabel'),
    valueSetter: adjDisputeValueSetter,
    filterValueGetter: getAdjDisputeFilterValue('ccDc2'),
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Dispute Code 3',
    field: 'ccDc3',
    editable: false,
    sortable: true,
    suppressMenu: false,
    columnSpan: 2,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'DisputeCode3CellRender',
    // showDropDownVal: true,
    isBgColor: true,
    bgColorName: 'bgColorForCcDc3',
    // dropDownValueCol: 'ccDc3ValWithLabel',
    valueGetter: getAdjDisputeExportValue('ccDc3ValWithLabel'),
    valueSetter: adjDisputeValueSetter,
    filterValueGetter: getAdjDisputeFilterValue('ccDc3'),
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Rebate Amt Invoiced',
    field: 'rebateAmtInvoice',
    comparator: amountComparator,
    cellClass: 'frr-input-width-90per ',
    editable: false,
    sortable: true,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_190,
    cellEditor: MaxLengthNumericEditor,
    isTextColorRed: true,
    printPrefixValue: '$ ',
    isBgColor: true,
    bgColorName: 'bgColorForrebateAmtInvoice',
    cellRenderer: 'RebateAmtInvoiceCellRender',
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
    sortingOrder: ['desc', 'asc'],
    exportZeroesTwo: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Invoice Correction Amt',
    field: 'invoiceCorrectionAmt',
    comparator: amountComparator,
    cellClass: 'frr-input-width-90per ',
    editable: false,
    sortable: true,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_190,
    cellEditor: MaxLengthNumericEditor,
    isTextColorRed: true,
    printPrefixValue: '$ ',
    isBgColor: true,
    bgColorName: 'bgColorForInvoiceCorrectionAmt',
    cellRenderer: 'InvoiceCorrectionCellRender',
    suppressKeyboardEvent: (params) => {
      const rowIndex = params.node.rowIndex;
      const e = params.event;
      const api = params.api;
      const colName = 'withheldInvoiceAmt';
      if (!e.shiftKey && e.key === 'Tab') {
        requestAnimationFrame(() => {
          // console.log('ROSI-2347');
          // Move focus
          api.setFocusedCell(rowIndex, colName);
          // FORCE SCROLL (horizontal + vertical)
          api.ensureIndexVisible(rowIndex);
          api.ensureColumnVisible(colName);
          const nextElement = document.getElementById(`${colName}${rowIndex}`);
          if (nextElement) {
            nextElement.select();
            nextElement.focus();
          }
        });
      } else if (e.shiftKey && e.key === 'Tab') {
        const colNameDP = 'ccDc3';
        const timeId = setTimeout(() => {
          // console.log('ROSI-2362');
          // Move focus
          api.setFocusedCell(rowIndex, colNameDP);
          // FORCE SCROLL (horizontal + vertical)
          api.ensureIndexVisible(rowIndex);
          api.ensureColumnVisible(colNameDP);
          const nextElement = document.getElementById(
            `${colNameDP}${rowIndex}`
          );
          if (nextElement) {
            nextElement.focus();
          }
          clearTimeout(timeId);
        }, 1000);
      }
    },
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
    sortingOrder: ['desc', 'asc'],
    exportZeroesTwo: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Amt Owed this NDC',
    field: 'amountOwedNdc',
    comparator: amountComparator,
    cellClass: 'frr-input-width-90per ',
    editable: false,
    sortable: true,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    isTextColorRed: true,
    printPrefixValue: '$ ',
    isBgColor: true,
    bgColorName: 'bgColorForAmtOwedNDC',
    cellRenderer: 'AmtOwedThisNDCCellRender',
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
    sortingOrder: ['desc', 'asc'],
    exportZeroesTwo: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
  {
    headerName: 'Withheld Invoice Amt',
    field: 'withheldInvoiceAmt',
    comparator: amountComparator,
    editable: false,
    cellClass: 'frr-input-width-90per ',
    sortable: true,
    suppressMenu: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    isTextColorRed: true,
    printPrefixValue: '$ ',
    isBgColor: true,
    bgColorName: 'bgColorForWithheldInvoiceAmt',
    cellRenderer: 'WithheldInvoiceAmtCellRender',
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
    sortingOrder: ['desc', 'asc'],
    exportZeroesTwo: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    suppressKeyboardEvent: (params) => {
      const e = params.event;
      const key = params.event.key;
      const rowIndex = params.node.rowIndex;
      const api = params.api;
      const colName = 'invoiceCorrectionAmt';
      if (e.shiftKey && key === 'Tab') {
        const timeId = setTimeout(() => {
          // console.log('ROSI-2494');
          // Move focus
          api.setFocusedCell(rowIndex, colName);
          // FORCE SCROLL (horizontal + vertical)
          api.ensureIndexVisible(rowIndex);
          api.ensureColumnVisible(colName);
          const nextElement = document.getElementById(`${colName}${rowIndex}`);
          if (nextElement) {
            nextElement.select();
            nextElement.focus();
          }
          clearTimeout(timeId);
        }, 1000);
      }
    },
  },
  {
    headerName: 'Paid Amt',
    field: 'paidAmt',
    comparator: amountComparator,
    cellClass: 'frr-input-width-90per ',
    editable: false,
    sortable: true,
    resizable: false,
    suppressMenu: false,
    minWidth: Styles.Width_190,
    cellEditor: MaxLengthNumericEditor,
    cellRenderer: 'PaidAmtCellRender',
    isTextColorRed: true,
    printPrefixValue: '$ ',
    isBgColor: true,
    bgColorName: 'bgColorForPaidAmt',
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
    sortingOrder: ['desc', 'asc'],
    exportZeroesTwo: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    suppressKeyboardEvent: (params) => {
      const e = params.event;
      const key = params.event.key;
      const rowIndex = params.node.rowIndex + 1;
      const api = params.api;
      const colName = 'ccCommentsExist';
      const lengthGrid = params.node.rowHeight;
      if (!e.shiftKey && key === 'Tab') {
        if (rowIndex !== lengthGrid) {
          // debounce for next row select
          const timeId = setTimeout(() => {
            // console.log('ROSI-2561');
            // Move focus
            api.setFocusedCell(rowIndex, colName);
            // FORCE SCROLL (horizontal + vertical)
            api.ensureIndexVisible(rowIndex);
            api.ensureColumnVisible(colName);
            api.forEachNode(
              (node) => node.rowIndex === rowIndex && node?.setSelected(true)
            );
            const nextElement = document.getElementById(
              `${colName}${rowIndex}`
            );
            if (nextElement) {
              nextElement.focus();
            }
            clearTimeout(timeId);
          }, 1500);
        }
      } else if (e.shiftKey && key === 'Tab') {
        const timeId = setTimeout(() => {
          const colNameSel = 'withheldInvoiceAmt';
          const rowIndexSel = rowIndex - 1;
          // console.log('ROSI-2583');
          // Move focus
          api.setFocusedCell(rowIndexSel, colNameSel);
          // FORCE SCROLL (horizontal + vertical)
          api.ensureIndexVisible(rowIndexSel);
          api.ensureColumnVisible(colNameSel);
          const nextElement = document.getElementById(
            `${colNameSel}${rowIndexSel}`
          );
          if (nextElement) {
            nextElement.select();
            nextElement.focus();
          }
          clearTimeout(timeId);
        }, 1000);
      }
    },
  },
];
export const SummaryGridTableHead = [
  {
    headerName: 'Current Principal Amt',
    field: 'currentPrincipalAmount',
    editable: false,
    sortable: false,
    suppressMenu: false,
    isTextColorRed: true,
    hideFilterIcon: true,
    minWidth: Styles.Width_130,
    cellEditor: MaxLengthNumericEditor,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellRenderer: 'CurrentPrincipalAmtCellRender',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Total Interest Calculated',
    field: 'totalInterestCalc',
    editable: false,
    sortable: false,
    suppressMenu: false,
    hideFilterIcon: true,
    isTextColorRed: true,
    minWidth: Styles.Width_130,
    cellEditor: MaxLengthNumericEditor,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellRenderer: 'TotalInterestCalcCellRender',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Total Principal Paid',
    field: 'totalPrincipalPaid',
    editable: false,
    sortable: false,
    hideFilterIcon: true,
    suppressMenu: false,
    isTextColorRed: true,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellRenderer: 'TotalPrincipalPaidCellRender',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Principal Paid: This Check',
    field: 'principalPaid',
    editable: false,
    sortable: false,
    hideFilterIcon: true,
    suppressMenu: false,
    isTextColorRed: true,
    minWidth: Styles.Width_180,
    cellEditor: MaxLengthNumericEditor,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellRenderer: 'PrincipalPaidCellRender',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Total Int.Paid',
    field: 'totalIntPaid',
    editable: false,
    sortable: false,
    hideFilterIcon: true,
    suppressMenu: false,
    isTextColorRed: true,
    minWidth: Styles.Width_100,
    cellEditor: MaxLengthNumericEditor,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellRenderer: 'TotalIntPaidCellRender',
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
    sortingOrder: ['desc', 'asc'],
  },
  {
    headerName: 'Total Int.Settled',
    field: 'totalIntSettled',
    editable: false,
    sortable: false,
    hideFilterIcon: true,
    suppressMenu: false,
    isTextColorRed: true,
    resizable: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellRenderer: 'TotalIntSettledCellRender',
    minWidth: Styles.Width_100,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: { textAlign: 'right', 'border-right-color': Styles.BorderColor },
  },
  {
    headerName: 'Interest Paid: This check',
    field: 'intPaid',
    editable: false,
    sortable: false,
    hideFilterIcon: true,
    suppressMenu: false,
    isTextColorRed: true,
    resizable: false,
    wrapHeaderText: true,
    autoHeaderHeight: true,
    cellRenderer: 'IntPaidCheckAmtCellRender',
    printPrefixValue: '$ ',
    minWidth: Styles.Width_171,
    cellEditor: MaxLengthNumericEditor,
    cellStyle: (params) => {
      if (params.data?.bgColor?.toString() === '11534335') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#f1f511',
        };
      }
      if (params.data?.bgColor?.toString() === '00b300') {
        return {
          'border-right-color': Styles.BorderColor,
          backgroundColor: '#a0c0a0',
        };
      }
      return { 'border-right-color': Styles.BorderColor };
    },
  },
];
export const NDCTableHead = [
  {
    headerName: 'NDC',
    field: 'ndc',
    sort: 'asc',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    minWidth: Styles.Width_171,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterValueGetter: (params) => {
      if (params.data?.isBottomRow) return '';
      return removeWhiteSpaceForNDC(params.data?.ndc) ?? '';
    },
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
      textMatcher: ndcTextMatcher,
    },
  },
  {
    headerName: 'Drug Name',
    field: 'drugName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    resizable: false,
    cellRenderer: 'DrugNameCellRenderer',
    cellClass: 'frr-ellipsis-text',
    cellEditor: MaxLengthNumericEditor,
    minWidth: Styles.Width_300,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];
